var React = require('react');

function Questionmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 5.47739C0 -1.55697 13.1613 -2.01086 13.1613 5.25041C13.1613 9.56164 8.85011 9.3346 7.94213 13.4196C7.48817 15.4618 4.76512 15.2347 4.76512 12.9656C4.76512 9.10847 7.94214 8.88143 9.3034 6.38535C10.2114 4.57023 8.62243 2.75424 6.80732 2.75424C2.95017 2.75424 4.31123 7.06548 1.81515 7.06548C0.907196 7.06548 3.96107e-05 6.38451 3.96107e-05 5.47735L0 5.47739ZM6.35323 20C3.6301 20 3.85715 15.9158 6.35323 15.9158C9.07635 15.9158 9.07635 20 6.35323 20Z","fill":"#1943EF"}));
}

Questionmark.defaultProps = {"width":"14","height":"20","viewBox":"0 0 14 20","fill":"none"};

module.exports = Questionmark;

Questionmark.default = Questionmark;
